import React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IStyle } from "../../../Types/Style";

import * as actions from "../actions";
import { Section } from "../components/common/containers";
import BrandColors from "./BrandColors";
import CustomLessCode from "./CustomLessCode";

interface ICustomStyleProps {
  style: IStyle;
  modifyLessCode: (lessCode: string) => void;
}

interface ICustomStyleDispatchProps {
  dismissPatchAlert: () => void;
}

type CustomStyleProps = ICustomStyleDispatchProps & ICustomStyleProps;

const CustomStyle: React.FC<CustomStyleProps> = props => {
  const [useCustomLess, setUseCustomLess] = React.useState(false);
  const toggleMode = () => {
    props.dismissPatchAlert();
    setUseCustomLess(!useCustomLess);
  };
  return (
    <Section>
      {useCustomLess ? (
        <CustomLessCode {...props} toggleMode={toggleMode} />
      ) : (
        <BrandColors {...props} toggleMode={toggleMode} />
      )}
    </Section>
  );
};

const mapDispatchToProps = (dispatch: Dispatch): ICustomStyleDispatchProps => ({
  dismissPatchAlert: () => dispatch(actions.dismissPatchAlert()),
});

export default connect(undefined, mapDispatchToProps)(CustomStyle);
